<section class="w-full h-full flex flex-wrap justify-center content-start py-6 px-[20px] md:p-8 overflow-x-hidden dark:bg-gray-800">

    <div class="w-full flex justify-between items-center mb-4">
        <span class="flex justify-start icon chevron-right-regular text-lg cursor-pointer text-gray-800"
            [ngClass]="{'hidden': authView == authStepEnum.userName}" (click)="back()"></span>
        <span
            class="hidden md:flex w-full justify-end icon dismiss-regular text-gray-800 text-lg font-semibold cursor-pointer text-end"
            (click)="closeDialog()"></span>
    </div>


    <main class="w-full h-[calc(100%-4%)] flex flex-wrap justify-center content-start">
        @if (authView !== authStepEnum.userName && authView !== authStepEnum.registeration) {
        <picture class="md:hidden w-full flex flex-wrap justify-center content-center mb-8">
            <img src="https://cloud.behkhaan.ir/assets/images/auth/behkhaan-logo.svg" alt="">
        </picture>

        }


        @if (authView === authStepEnum.userName) {
        <app-username-form-presenter class="w-full md:w-1/2" [getOtpLoading]="getOtpLoading"
            (onUserNameChanged)="checkUserState($event)"
            (onLoginWithPasswordDesired)="setAuthView($event)"></app-username-form-presenter>
        }

        @else if (authView === authStepEnum.otp_verification) {
        <app-otp-verification-presenter [verifyLoading]="verifyLoading" [initialData]="initialData"
            (onCodeChanged)="verifyCode($event)" (onResetAuthFlow)="resetFlow()"
            (onLoginWithPasswordDesired)="setAuthView($event)"
            (onRequestOtp)="checkUserState($event)"></app-otp-verification-presenter>
        }
        @else if (authView === authStepEnum.registeration) {
        <div class="w-full flex h-full">
            <app-register-form-presenter [registerStep]="registerStep" [registerationLoading]="registerationLoading"
                [googleData]="googleData" [verificationCode]="verificationCode"
                [isUsernameDuplicated]="isUsernameDuplicated" [usernameCheckLoading]="usernamecheckLoading"
                (onUsernameCheckLoading)="changeUserLoading()" (onUserNameChanged)="checkUserName($event)"
                (onRegisterSubmited)="signup($event)" (onOtpDesired)="setAuthView($event)"
                (onRegisterStep)="changeRegisteraionStep($event)"></app-register-form-presenter>
        </div>
        }

        @else if (authView === authStepEnum.login) {
        <app-login-form-presenter [loginLoading]="loginLoading" (onOtpDesired)="setAuthView($event)"
            (onForgetPassDesired)="setAuthView($event)" (onLoginSubmitted)="loginWithPassword($event)">
        </app-login-form-presenter>
        }

        @else if (authView === authStepEnum.forget_pass) {
        <app-forget-password-presenter [submitUsernameLoading]="getOtpLoading" [verificationLoading]="verifyLoading"
            [confirmPasswordLoading]="confirmPasswordLoading" [step]="forgetFlowStep"
            [verificationCode]="verificationCode" (onOtpDesired)="setAuthView($event)"
            (onUserNameSubmitted)="getForgetPassCode($event)" (onCodeChanged)="verifyCode($event)"
            (onNewPasswordSubmitted)="changePassword($event)"></app-forget-password-presenter>
        }

    </main>
</section>